var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.66 3.91733C25.8553 3.20278 26.7496 2.07764 27.176 0.751995C26.0529 1.4184 24.8241 1.88783 23.5427 2.13999C21.7661 0.260698 18.9514 -0.196637 16.6712 1.02354C14.3911 2.24371 13.21 4.83931 13.788 7.35999C9.1875 7.12903 4.90131 4.95588 1.99602 1.38133C0.479807 3.99656 1.25462 7.3397 3.76669 9.02133C2.8583 8.99212 1.97006 8.74618 1.17602 8.30399C1.17602 8.32799 1.17602 8.35199 1.17602 8.37599C1.17655 11.1002 3.09652 13.4468 5.76669 13.9867C4.92411 14.2159 4.0403 14.2496 3.18269 14.0853C3.93362 16.415 6.08076 18.011 8.52802 18.0587C6.50113 19.6495 3.99799 20.5122 1.42135 20.508C0.964648 20.5087 0.508301 20.4824 0.0546875 20.4293C2.67121 22.1107 5.71651 23.0031 8.82669 23C13.1537 23.0297 17.3121 21.3239 20.3717 18.264C23.4313 15.2042 25.1368 11.0457 25.1067 6.71866C25.1067 6.47066 25.1009 6.22399 25.0894 5.97866C26.21 5.1688 27.1771 4.16553 27.9454 3.016C26.9014 3.47875 25.794 3.78256 24.66 3.91733Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwitter);
export default __webpack_public_path__ + "static/media/ic_twitter.bad86c80e26a72a048713b2878dc4214.svg";
export { ForwardRef as ReactComponent };